module.exports = __webpack_public_path__ + "img/zuopin4.9794916d.jpg";